import React from 'react';
import Timely2Logo from "../../../images/background/timelyDtl.png"

const TimelyStatic = (props) => {
    return (
        <div>
            <div style={{ marginTop: 8 }}>
                <img src={Timely2Logo} alt='' style={{ width: '100%', borderRadius: 4 }} />
            </div>
            <div style={{ marginTop: 8, fontSize: 14, fontWeight: 400, marginBottom: 16 }}>
                <p>Та timely цаг бүртгэлийн холбогчийг ашигласнаар <a href='https://timely.mn' target='_blank'>timely.mn</a> цаг бүртгэлийн системд бүртгэгдсэн ажилтнуудынхаа ирцийн бүртгэлийг татаж цалингаа хялбар бодох боломжтой болох юм.
                    <br /><br />
                    <span style={{ fontWeight: 'bold' }}>timely.mn-ий тухай:</span><br />
                    Location based аппликэйшн бөгөөд ХХНХолбоотой хуулийн  шаардлагад бүрэн нийцсэн платформ юм. Энэхүү платформ нь нэмэлт төхөөрөмж ашиглахгүйгээр ажилтан Timely апп-аар ИРЭХ/ЯВАХ цагаа бүртгүүлэх, өөрийн ирц мэдээллээ хянах, бүх төрлийн цагийн хүсэлтүүдээ илгээх, гадуур ажиллах, олон байршлаас цагаа бүртгүүлэх боломжийг олгодог. Мөн 1-ээс дээш ажилтантай төрийн болон бизнесийн бүхий л байгууллагын ажилтны цаг бүртгэл, ирцийн тайлан гаргах процесс үйл ажиллагааг автоматжуулдаг.
                    Та манай платформыг 14 хоногийн хугацаанд үнэ төлбөргүй ашиглаж, туршиж үзэхийг хүсвэл <a href='https://admin.timely.mn/register.php' target='_blank'>энд дарна уу</a>.
                </p>
            </div>
        </div>
    );
}

export default TimelyStatic;